/* eslint-disable no-undef */
import React, { useState, useEffect } from 'react';
import classnames from 'classnames';
import {connect} from 'react-redux';
import {FormattedMessage} from 'react-intl';
import {
  addAllProducts,
  loadProductCart,
  updateProductCart
} from '@ignitesales/neuro-application/src/actions/product-action-creators';
import {actionCompleted, actionStarted} from "@ignitesales/neuro-application/src/actions/question-action-creators";
import { goToNextPage } from "@ignitesales/neuro-application/src/actions/navigation-action-creators";
import { flatProductList } from "@ignitesales/neuro-application/src/util/productUtil";
import Product from '../Product';
import ProductCart from '../ProductCart';
import Footer from "../Footer";
import {clearNotifications} from "../Notifications";
import AnswersList from "../AnswersList";


function SummaryPage(props) {
  const {
    addToCartClicked,
    answers,
    answersWithPageInfo,
    classname,
    loadProducts,
    previousPageClicked,
    productApplyClicked,
    productCart,
    products,
    removeFromCartClicked,
    user
  } = props;

  useEffect(() => {
    loadProducts();
  }, []);

  const cssBEM = 'summaryPage';
  const classes = classnames(cssBEM, classname);
  const productsRecommendedList = flatProductList(products);
  const productsInCart = productsRecommendedList.filter(p => true);
  const [ showCart, setShowCart ] = useState(true);


  const renderProduct = product => {
    const isInTheCart = (productCart || new Set([])).has(product.id.toString());
    const addToCart = () => {
      productApplyClicked({ productId:product.id, completed:false });
      addToCartClicked(productCart, product.id);
    };
    const removeFromCart = () => {
      removeFromCartClicked(productCart, product.id);
    };
    return <Product
      isSelected={isInTheCart}
      key={ product.id }
      onAddCartClick={addToCart}
      onRemoveCartClick={removeFromCart}
      product={product}
    />;
  };

  return <div className={classes}>
    <div className="container">
      <div className={`${cssBEM}__section product-cart-section`}>
        <div className="product-cart-section__blurb">
          <FormattedMessage id="summary.subtitle" tagName="h6" />
          <h2 className={`${cssBEM}__section-title`}><FormattedMessage id="summary.title"/></h2>
          <p className={`${cssBEM}__section-subtext`}><FormattedMessage id="summary.subtext" /></p>
          {/* <ProductCartButton
              isSticky={sticky}
              onClick={() => setShowCart(true)}
              cartCount={productsInCart.length}
            /> */}
        </div>
      </div>

      <div className={`${cssBEM}__section`}>
        <div className={`${cssBEM}__products`}>
          { productsRecommendedList.map(p => renderProduct(p)) }
        </div>
      </div>
    </div>

    <div className={`${cssBEM}__answers`}>
      <div className="container">
        <h2 className={`${cssBEM}__section-title`}><FormattedMessage id="answers.title"/></h2>
        <p className={`${cssBEM}__section-subtext`}>
          <FormattedMessage id="answers.subtext" values={{
            returnLink: <span onClick={previousPageClicked}><FormattedMessage id="answers.subtext.previousPage" /></span>
          }}/>
        </p>
        <AnswersList answers={answersWithPageInfo} user={user} />
      </div>
    </div>

    <ProductCart
      answers={ answers }
      isOpen={ showCart }
      onClose={ () => setShowCart(false) }
      onRemoveFromCart={ id => removeFromCartClicked(productCart, id) }
      productApplyClicked={ productApplyClicked }
      selectedProducts={ productsInCart }
    />

    <Footer/>
  </div>;
}

export default connect((state) => {
  const answers = state.answers || {};
  const answersWithPageInfo = state.answersWithPageInfo || {};
  const products = state.products || {};
  const productCart = state.productCart;
  const user = state.user || {};
  return {
    answers,
    answersWithPageInfo,
    products,
    productCart: Array.isArray(productCart) ? new Set(productCart) : productCart,
    user
  };
}, dispatch => {
  return {
    addToCartClicked: (products, productId) => {
      dispatch(updateProductCart(products, productId));
    },
    removeFromCartClicked: (products, productId) => {
      dispatch(updateProductCart(products, productId, true));
    },
    addAllProducts: listOfProducts => {
      dispatch(addAllProducts(listOfProducts));
    },
    previousPageClicked: () => {
      clearNotifications();
      dispatch(goToNextPage(true));
    },
    loadProducts: () => {
      dispatch(loadProductCart());
    },
    productApplyClicked: ({productId, completed}) => {
      const params = {
        actionName: 'productApplyClicked',
        productId
      };
      dispatch(completed ? actionCompleted(params) : actionStarted(params));
    }
  };
})(SummaryPage);
